import { combineReducers } from 'redux';

import { ADD_CONTACTS_SUCCESS } from 'modules/contactLists/actionTypes';
import * as types from 'modules/contactMembers/actionTypes';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { createReducer } from 'utils/ReduxUtils';

import filters from './filters';

const GENERIC_SLICE_CONFIG = {
  global: {
    selectId: (entity) => entity?.contactMemberId ?? entity?.id,
  },
};

/**
 * @typedef {{
 *   loading: {
 *    editing: boolean,
 *    deleting: boolean,
 *    updating: boolean,
 *   },
 *   editing: { id: string | null },
 *   filters: import('modules/campaigns/reducers/ui/filters').filtersState,
 *   contactMembers: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * }} ContactMemberUIReducer
 */

/** @type {ContactMemberUIReducer} */
export default combineReducers({
  filters,
  editing: combineReducers({
    id: createReducer(null, {
      [types.OPEN_MODAL_EDIT]: (_, { payload: contactMemberId }) => contactMemberId,
      [types.CLOSE_MODAL_EDIT]: () => null,
      [types.UPDATE_CONTACT_MEMBER_SUCCESS]: () => null,
    }),
  }),
  contactMembers: createSearchReducers(types.FETCH_CONTACT_MEMBERS, {
    ids: { [ADD_CONTACTS_SUCCESS]: (state, { payload: contactMember }) => state.concat(contactMember.id) },
  }),
  loading: combineReducers({
    editing: loadingArraySlice(types.UPDATE_CONTACT_MEMBER, GENERIC_SLICE_CONFIG),
    deleting: loadingArraySlice(types.DELETE_CONTACT_MEMBERS, GENERIC_SLICE_CONFIG),
    updating: loadingArraySlice(types.UPDATE_CONTACT_MEMBER, GENERIC_SLICE_CONFIG),
  }),
});
